// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__hP4U4","item":"PaymentsMobile_item__JVABn","label":"PaymentsMobile_label__2f_Qx","amount":"PaymentsMobile_amount__3ufRj"};